import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Countries from "./pages/Countries";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import ServiceDetail from "./pages/ServiceDetail";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";

// Admin
import { AdminProvider } from "./context/AdminContext";
import PrivateRoute from "./admin/PrivateRoute";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminDashboard from "./admin/pages/AdminDashboard";
import AdminEnquiries from "./admin/pages/AdminEnquiries";
import AdminTestimonials from "./admin/pages/AdminTestimonials";
import AdminServices from "./admin/pages/AdminServices";

function PublicLayout() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/countries" element={<Countries />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

function AdminSection() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <AdminLayout><AdminDashboard /></AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/enquiries"
        element={
          <PrivateRoute>
            <AdminLayout><AdminEnquiries /></AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/testimonials"
        element={
          <PrivateRoute>
            <AdminLayout><AdminTestimonials /></AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/services"
        element={
          <PrivateRoute>
            <AdminLayout><AdminServices /></AdminLayout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminSection />} />
          <Route path="/*" element={<PublicLayout />} />
        </Routes>
      </BrowserRouter>
    </AdminProvider>
  );
}

export default App;
